module.exports = __webpack_public_path__ + "static/media/bigpic-sub-02.62af166b.jpg";